import { useContext } from 'react';
import FormattedNumber from './FormattedNumber';
import NumberTypes from '../constants/NumberTypes';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedPercentage(props) {
  useContext(I18nHMRContext);
  return /*#__PURE__*/_jsx(FormattedNumber, Object.assign({
    style: NumberTypes.PERCENTAGE
  }, props));
}
FormattedPercentage.displayName = 'FormattedPercentage';
export default FormattedPercentage;